import { createSlice } from '@reduxjs/toolkit';
import { PACKAGE_NAME } from '../constants';
import { RootState } from '../types';

const initialState = false;

const slice = createSlice({
    name: `${PACKAGE_NAME}/showMore`,
    initialState,
    reducers: {
        enableShowMore: () => true
    }
});

export default slice.reducer;
export const { name, actions: { enableShowMore } } = slice;

export const selectShowMore = (state: RootState) => state[slice.name];
